import moment from "moment";
export var formatNumber = function (number) {
    return number.toLocaleString("en-US");
};
export var formatDate = function (date, format) {
    if (format === void 0) { format = "DD-MM-YYYY"; }
    moment.locale("es");
    var dateMoment = moment(date);
    return "".concat(dateMoment.format(format)).toUpperCase();
};
export var formatDateViewPayment = function (date) {
    var dateMoment = moment(date);
    return "".concat(dateMoment.date(), "-").concat(dateMoment.month() + 1, "-").concat(dateMoment.year());
};
